import "video.js/dist/video-js.css";

import { AiOutlineClockCircle } from "react-icons/ai";
import { BiWebcam } from "react-icons/bi";
import { COLORS } from "../../../styles/colors";
import { MdOndemandVideo } from "react-icons/md";
import { ProjectInfo } from "../../../../APITypes/ProjectInfo.cs";
import ShowHideSpanMobile from "./ShowHideSpanMobile";
import { Skeleton } from "../../../ui/skeleton";
import { durationMsToShortString } from "../../../../helpers/helpers";

const MetaAreaDiv = (props: {
  pid: string;
  meta: ProjectInfo;
  widgetMode: boolean;
}) => {
  return (
    // MAIN RENDER ////////////////////////////////////////////////////////////////
    <div className="pl-3 -mb-1 mt-[1px] shadow-inner">
      <div className="flex items-center md:pl-4  *:dark:bg-white/10 *:bg-zinc-200 *:p-1 *:px-2 *:pl-3 *:rounded-full text-sm gap-4  dark:text-stone-200 text-stone-950 p-1 ">
        <span className="items-center gap-1 hidden md:flex">
          <ShowHideSpanMobile
            mobileContent={<MdOndemandVideo />}
            desktopContent={`Research Duration : `}
          />
          <span className="text-accent flex  gap-1  px-1 dark:text-[#f9d670]">
            {props.meta.minutes}{" "}
            <span className="hidden md:block">minutes</span>
          </span>
        </span>

        {props.meta.events > 1 ? (
          <span className="flex items-center gap-1">
            <span className="hidden md:block">{`Events : `}</span>
            <span className="md:hidden">
              <MdOndemandVideo />
            </span>
            <span className="text-accent dark:text-[#f9d670]">
              {props.meta.events}
            </span>
          </span>
        ) : null}
        <span className="flex items-center gap-1">
          <ShowHideSpanMobile
            mobileContent={<BiWebcam />}
            desktopContent={
              !props.meta.highlights
                ? "Highlights:"
                : `Highlight${props.meta.highlights > 1 ? "s" : ""}:`
            }
          />
          <span className="text-accent dark:text-[#f9d670]">
            {props.meta.highlights}
          </span>
        </span>
        <span className="flex items-center gap-1">
          <ShowHideSpanMobile
            mobileContent={
              <AiOutlineClockCircle
                className="dark:text-stone-200 text-stone-950"
                size={14}
              />
            }
            desktopContent={`Playback Time:`}
          />
          <span className="text-accent dark:text-[#f9d670]">
            {durationMsToShortString(props.meta?.playbackDurationMs, true)}
          </span>
        </span>
      </div>
    </div>
  );
};

export default MetaAreaDiv;
